module.exports = __webpack_public_path__ + "img/news_1_TC.b71dc2c8.png";